import { defineMessages } from 'react-intl-next';

export default defineMessages({
	starred: {
		id: 'atlassian-studio-common.picker.favourite',
		defaultMessage: 'Starred',
		description: 'Label for starred project/spaces in picker',
	},
	all: {
		id: 'atlassian-studio-common.picker.all',
		defaultMessage: 'All',
		description: 'Label for remaining project/spaces in picker',
	},
	pickerLabel: {
		id: 'atlassian-studio-common.picker.label',
		defaultMessage: 'Jira projects and Confluence spaces search picker',
		description: 'Accessibility label for the picker search input',
	},
	pickerLabelGalaxia: {
		id: 'atlassian-studio-common.picker.label-galaxia',
		defaultMessage: 'Jira and Confluence spaces search picker',
		description: 'Accessibility label for the picker search input',
	},
});
